// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/portfolio-uncertainty/app/css/app.css
// module id = 665
// module chunks = 0